import LayoutSistema from './LayoutSistema';

// [2026-10-20] A casca Marçal Sistema é a única desde 07/10. A casca antiga
// (Navbar + Sidebar + modo CRM) saiu do código: ninguém mais a via.
export function LayoutEscritorio() {
  return <LayoutSistema />;
}
